<div class="row selection-list">
    @if (allowDefault) {
        <div class="selection-item col-md-3">
            <div class="tile" [class.selected-item]="!equippedId()" (click)="select(null)">
                @if (defaultPreviewClass) {
                    <div class="tile-swatch" [ngClass]="defaultPreviewClass"></div>
                }
                <div class="tile-description">
                    <strong>{{ defaultLabel }}</strong>
                </div>
            </div>
        </div>
    }
    @for (item of items(); track item.Id) {
        <div class="selection-item col-md-3">
            <div class="tile" [class.selected-item]="equippedId() === item.Id" (click)="select(item)">
                <img class="tile-image" [class.tile-image-round]="roundImages" [src]="item.ImagePath" [alt]="item.Name" />
                <div class="tile-description">
                    <strong>{{ item.Name }}</strong><br />
                    {{ item.Description }}
                </div>
            </div>
        </div>
    }
</div>
@if (!items().length) {
    <div class="row empty">
        <div class="col">You don't own any of these yet!</div>
    </div>
}
